import LocationIcon from '@/common/assets/icons/locationIcon.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon.tsx';
import BulletTypography from '@/common/components/base/typography/BulletTypography.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { LocationDetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import LocationDetailCardItemModal from '@/common/components/DetailCard/items/locationDetailCardItem/LocationDetailCardItemModal.tsx';
import useModal from '@/common/hooks/useModal.ts';
import { Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default ({
  value,
  keyName,
  address,
  modalTitle,
  backgroundColor = 'black-3',
  hasBullet = true,
}: Omit<LocationDetailCardItemData, 'value'> & { value: string }) => {
  const { open, closeModal, openModal } = useModal();
  return (
    <Flex justifyContent="space-between">
      {hasBullet ? (
        <BulletTypography
          backgroundColor={backgroundColor}
          textStyle="b2"
          color="black-3"
        >
          {keyName}
        </BulletTypography>
      ) : (
        <Typography textStyle="b2" color="black-3">
          {keyName}
        </Typography>
      )}
      <Flex onClick={openModal} alignItems="center">
        <CustomIcon backgroundColor="purple-7" width={26} height={26}>
          <LocationIcon stroke={token('colors.purple-primary')} />
        </CustomIcon>
        <Typography mr="7px" textStyle="b2" color="black-1">
          {value}
        </Typography>
      </Flex>
      <LocationDetailCardItemModal
        open={open}
        closeModal={closeModal}
        title={modalTitle}
        address={address}
      />
    </Flex>
  );
};
